module.exports = __webpack_public_path__ + "static/media/export.a0d62a88.svg";